import { SET_MESSAGES_LIST, SET_MESSAGES_LOADING } from './constants'

const initialState = {
    list: [],
    pagination: {},
    loading: false,
}

const reducer = (state = initialState, { type, payload, error }) => {
    switch (type) {
        case SET_MESSAGES_LIST:
            return {
                ...state,
                list: payload.messages,
                pagination: payload.pagination,
                loading: false,
            }
        case SET_MESSAGES_LOADING:
            return {
                ...state,
                loading: true,
            }
        default:
            return state
    }
}

export default reducer
